import React from 'react'
import { Pipeline } from '@morningtrain/react-helpers'
import TriggerPipelineOnEvent from 'services/events/TriggerPipelineOnEvent'

export default function OnEventPipeline ({ name, children, ...forwardProps }) {
  return (
    <Pipeline {...forwardProps}>
      <TriggerPipelineOnEvent name={name} />
      {children}
    </Pipeline>
  )
}
